import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabCreazioneNota.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabCreazioneNota.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabCreazioneNota.vue?vue&type=script&lang=js&
// module id = 353
// module chunks = 0